import covidService from '../services/covid.service';

const handlers = {
    covid: {
        session: {
            set: 'covid_session_set'
        }
    }
};

const initVuexState = function(state) {
    state.covid = {
        session: null
    };
};

const initGetters = function(getters) {
    getters.covid = state => state.covid;
};

const initActions = function(actions) {
    actions[handlers.covid.session.set] = ({ commit }, session) => commit(handlers.covid.session.set, session);
};

const initMutations = function(mutations) {
    mutations[handlers.covid.session.set] = (state, session) => (state.covid.session = session);
};

const initAppState = function(appState, store) {
    appState.covid = {
        session: {
            get: () => store.getters.covid.session,
            open: async language => {
                let session = await covidService.openSession(language);
                store.dispatch(handlers.covid.session.set, session);
            },
            openDemo: async language => {
                let session = await covidService.openDemoSession(language);
                store.dispatch(handlers.covid.session.set, session);
            },
            close: async () => {
                if (store.getters.covid.session) {
                    await covidService.closeSession(store.getters.covid.session.sessionId);
                }
                store.dispatch(handlers.covid.session.set, null);
            }
        }
    };
};

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};



// WEBPACK FOOTER //
// ./_common/data/covid.js